import { render } from "./MasterRules.vue?vue&type=template&id=059f3eae&scoped=true"
import script from "./MasterRules.vue?vue&type=script&lang=js"
export * from "./MasterRules.vue?vue&type=script&lang=js"

import "./MasterRules.vue?vue&type=style&index=0&id=059f3eae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059f3eae"]])

export default __exports__